import { Pencil } from 'lucide-react';
import { Link } from 'react-router-dom';
import styles from './EditIconLink.module.css';
import { IconTooltip } from './IconTooltip';

interface EditIconLinkProps {
  to: string;
  label: string;
}

export const EditIconLink = ({ to, label }: EditIconLinkProps) => (
  <IconTooltip label="Edit">
    <Link to={to} className={styles.editIconLink} aria-label={label}>
      <Pencil aria-hidden="true" />
    </Link>
  </IconTooltip>
);
